import { createSlice } from "@reduxjs/toolkit";

const initialThemeState = { theme: "/space/index.css", program: "Space" };
const themeSlice = createSlice({
    name: "theme",
    initialState: initialThemeState,
    reducers: {
        setTheme(state, action) {
            state.theme = `/${action.payload.theme}/index.css`;
            state.program = action.payload.program;
        }
    },
});

export default themeSlice;